
(function() {
  'use strict';

  function initColorVariantsPopup() {
    const openBtn = document.querySelector('[data-open-color-popup]');
    const overlay = document.querySelector('[data-color-popup-overlay]');
    const closeBtn = document.querySelector('[data-close-color-popup]');

    if (!openBtn || !overlay) return;

    openBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closePopup();
      });
    }

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closePopup();
      }
    });

    function openPopup() {
      overlay.classList.add('is-open');
      document.body.classList.add('color-popup-open');

      if (closeBtn) {
        setTimeout(() => closeBtn.focus(), 100);
      }
    }

    function closePopup() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('color-popup-open');

      openBtn.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorVariantsPopup);
  } else {
    initColorVariantsPopup();
  }
})();
